import type { RaffleSortOption } from 'src/types/raffleFilters';

interface BackendSort {
  sortBy?: 'endDate' | 'ticketPrice' | 'ticketsSold' | 'createdAt';
  sortOrder?: 'asc' | 'desc';
}

export function mapSortToApiParams(sort: RaffleSortOption): BackendSort {
  switch (sort) {
    case 'default':
      return {};
    case 'recently_added':
      return { sortBy: 'createdAt', sortOrder: 'desc' };
    case 'expiring_soon':
      return { sortBy: 'endDate', sortOrder: 'asc' };
    case 'ticket_price_asc':
      return { sortBy: 'ticketPrice', sortOrder: 'asc' };
    case 'ticket_price_desc':
      return { sortBy: 'ticketPrice', sortOrder: 'desc' };
    case 'tickets_remaining_asc':
      return { sortBy: 'ticketsSold', sortOrder: 'desc' };
    case 'tickets_remaining_desc':
      return { sortBy: 'ticketsSold', sortOrder: 'asc' };
    case 'floor_price_asc':
    case 'floor_price_desc':
      return {};
    default:
      return {};
  }
}
